import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class UserService {


    static getUser(item) {

        const {
            page = 1,
            limit = 10,
            id = ""
        } = item || {};

        let api =
            `${API_BASE_URL}${API_PATHS.getusers}` +
            `?page=${page}&limit=${limit}`;

        // Optional pageId append
        if (id) {
            api += `&id=${id}`;
        }

        return axiosInstance.get(api);
    }


    static approveUser(item) {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.approveuser}`;

        return axiosInstance.post(api, item)
    }


    static getTeam(item) {
        const user = JSON.parse(localStorage.getItem("user"));

        const prefix = user?.role === "admin" ? "admin/" : "";

        const api = `${API_BASE_URL}${prefix}${API_PATHS.getTeam}`;

        const params = new URLSearchParams();

        if (item?.userId) {
            params.append("userId", item.userId);
        }

        return axiosInstance.get(api, {
            params,
        });
    }

    static getWallet(item) {

        let api = `${API_BASE_URL}${API_PATHS.getWallet}`;

        return axiosInstance.get(api);
    }

    static getuserWallet(item) {
        let api = `${API_BASE_URL}${API_PATHS.getuserWallet}`;

        const params = new URLSearchParams();

        if (item?.userId) params.append("userId", item.userId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }


        return axiosInstance.get(api, item);
    }

    static getBankDetails(item) {

        let api = `${API_BASE_URL}${API_PATHS.getBankDetails}`;

        return axiosInstance.get(api);
    }

    static getBankAccount(item) {

        let api = `${API_BASE_URL}${API_PATHS.getBankAccount}`;

        return axiosInstance.get(api);
    }


    static addBankDetails(item) {

        let api = `${API_BASE_URL}${API_PATHS.saveBankDetails}`;

        return axiosInstance.post(api, item);
    }


    static requestWithdrawal(item) {

        let api = `${API_BASE_URL}${API_PATHS.requestWithdrawal}`;

        return axiosInstance.post(api, item);
    }


    static getWithdrawalRequests(item) {
        const user = JSON.parse(localStorage.getItem("user"));

        const prefix = user?.role === "admin" ? "admin/" : "";

        const api = `${API_BASE_URL}${prefix}${API_PATHS.getWithdrawalRequests}`;

        const params = new URLSearchParams();

        if (item?.status) {
            params.append("status", item.status);
        }

        return axiosInstance.get(api, {
            params,
        });
    }



    static approveBankAccount(item) {

        let api = `${API_BASE_URL}${API_PATHS.approveBankAccount}`;

        return axiosInstance.post(api, item);
    }



    static approveWithdrawal(item) {

        let api = `${API_BASE_URL}${API_PATHS.approveWithdrawal}`;

        return axiosInstance.post(api, item);
    }

    static rejectWithdrawal(item) {

        let api = `${API_BASE_URL}${API_PATHS.rejectWithdrawal}`;

        return axiosInstance.post(api, item);
    }



    static editBankDetails(item) {

        let api = `${API_BASE_URL}${API_PATHS.editBankDetails}`;

        return axiosInstance.put(api, item);
    }


    static deleteBankDetails(id) {

        const api =
            `${API_BASE_URL}${API_PATHS.deleteBankDetails}/${id}`;

        return axiosInstance.delete(api);
    }

    // Method to remove user details from localStorage
    static removeUserDetails() {
        localStorage.removeItem('user');
    }

    // Method to get user details from localStorage
    static getUserDetails() {
        const user = localStorage.getItem('user');
        try {
            return user ? JSON.parse(user) : "";
        } catch (e) {
            console.error('Error parsing user details from localStorage', e);
            return null;
        }
    }

    // Method to set tokens in localStorage
    static setTokens(data) {
        localStorage.setItem("accessToken", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken)
    }
}

export default UserService;
